export const LONG = 'L';
export const GLOBAL = '22';
export const PUBLIC_DEMAND = 'P';

export default {
  LONG,
  GLOBAL,
  PUBLIC_DEMAND
};
